import { render, staticRenderFns } from "./AlertGroupTable.vue?vue&type=template&id=47440670&"
import script from "./AlertGroupTable.vue?vue&type=script&lang=js&"
export * from "./AlertGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports